var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('span',{staticClass:"text-h4 text-center"},[_vm._v("ĐANG TẢI DỮ LIỆU VUI LÒNG ĐỢI....")]),_c('br'),_c('Loader',{attrs:{"status":_vm.loader}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }